var map = {
	"./bologneseragusauce.jpg": 89,
	"./hotdog.jpg": 90,
	"./icecream.jpg": 45,
	"./noodle.jpg": 91,
	"./pasta.jpg": 44,
	"./shepard'spie.jpg": 92,
	"./spaghetti.jpg": 93,
	"./spaghettiwithgarlic,chilliandparsley.jpg": 94,
	"./stirfry.jpg": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;